import moment from 'moment';

// Lectura genérica: solo ISO, sin fallback al string español
function readCourseDate(course, isoField) {
    const ci = course?.comercialInformation;
    if (!ci || !ci[isoField]) return null;
    return moment.utc(ci[isoField]);
}

export function getCourseStartDate(course) {
    return readCourseDate(course, 'initialDateISO');
}
export function getCourseEndDate(course) {
    return readCourseDate(course, 'endDateISO');
}
export function getCourseInitBreak(course) {
    return readCourseDate(course, 'initBreakISO');
}
export function getCourseEndBreak(course) {
    return readCourseDate(course, 'endBreakISO');
}
export function getCloseCampusDate(course) {
    if (!course?.closeCampusDateISO) return null;
    return moment.utc(course.closeCampusDateISO);
}

// Formatea para display: "16 DE ABRIL 2026" desde el ISO (en UTC)
export function formatCourseStartDate(course) {
    const m = getCourseStartDate(course);
    return m ? m.locale('es').format('DD [DE] MMMM YYYY').toUpperCase() : 'A confirmar';
}

// --- Escritura: normaliza el Date del DateInput a medianoche UTC ---
export function toUTCMidnight(date) {
    if (!date) return null;
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    const ar = new Date(d.getTime() - 3 * 60 * 60 * 1000);
    return new Date(Date.UTC(ar.getUTCFullYear(), ar.getUTCMonth(), ar.getUTCDate(), 0, 0, 0, 0));
}

// --- Lectura para DateInput: ISO UTC -> Date local del mismo día calendario ---
export function isoToLocalDateInput(isoDate) {
    if (!isoDate) return null;
    const d = new Date(isoDate);
    if (isNaN(d.getTime())) return null;
    return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}